import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useOverlay } from '@dpdgroupuk/fmx-ui/components/Overlay';

import { useGoogleReCaptcha } from '@dpdgroupuk/react-google-recaptcha-v3';
import * as parcelSelectors from '../../store/selectors/searchParcels';
import { fetchSearchParcelByReferenceNumber } from '../../store/actions/parcels';
import { ACTION } from '../../constants/recaptcha';

export const useSearchParcels = ({ query }: { query: Object }) => {
  const dispatch = useDispatch();
  const { executeRecaptchaAsync } = useGoogleReCaptcha();

  const { showWhile } = useOverlay();
  const parcelData = useSelector(parcelSelectors.selectParcelsData);

  return useCallback(
    showWhile(async () => {
      const { reference, postcode } = query;
      const recaptchaToken = await executeRecaptchaAsync(ACTION.REFERENCE);

      if (parcelData.length) {
        return Promise.resolve(parcelData);
      }

      return dispatch(
        fetchSearchParcelByReferenceNumber(reference, postcode, recaptchaToken)
      );
    }),
    [query, parcelData, dispatch, executeRecaptchaAsync]
  );
};
